<template>
  <div ref="vueotp" class="vue-otp">
    <p
      class="message"
      v-bind:class="{ error: has_error }"
      v-if="display_message"
    >
      {{ message }}
    </p>
    <div v-if="!sub_confirmed">
      <div class="activation-inputs">
        <div
          class="form-group"
          v-bind:class="{ 'has-errors': errors.has('mobile_number') }"
        >
          <p class="text-normal">
            Please enter a valid me&amp;you mobile number to create an account.
          </p>
          <the-mask
            type="tel"
            :mask="['### ### #####', '### ### ####']"
            v-validate="'required|max:11|min:10'"
            name="mobile_number"
            data-vv-as="Mobile Number"
            placeholder="Enter Your Mobile Number eg. 061 555 9988"
            class="form-control"
            v-model="msisdn"
          />
          <transition name="slide">
            <span class="error-message" v-if="errors.has('mobile_number')"
              >A valid 10 digit SA mobile number is required (eg: 076 123
              4567).</span
            >
          </transition>
        </div>
        <div
          class="form-group"
          v-bind:class="{ 'has-errors': errors.has('simNumber') }"
        >
          <p class="text-normal">or</p>
          <p class="text-normal">
            A valid 19 digit active sim number (ICCID) (eg:
            8927071234567890123).
          </p>
          <the-mask
            mask="####-####-####-####-###"
            type="tel"
            v-validate="'required|digits:19'"
            name="simNumber"
            class="form-control"
            data-vv-as="SIM Number"
            v-model="sim_number"
            placeholder="Enter your sim number"
          />
          <span class="error-message" v-if="errors.has('simNumber')"
            >A valid 19 digit sim number (ICCID) is required (eg:
            8927071234567890123).</span
          >
        </div>
        <button
          type="button"
          class="btn-primary btn-block verify"
          v-on:click="confirmSubscriber"
        >
          Confirm Customer
        </button>
      </div>
    </div>
    <div v-if="sub_confirmed && !otp_sent">
      <div class="activation-inputs">
        <p class="text-normal">
          Please select the mobile number where we can send your One Time Pin.
        </p>
        <div class="form-group">
          <vue-toggle
            :options="contact_numbers"
            :default="contact_numbers[0]"
            :selected.sync="contact_no"
            class="row no-gutters"
          >
            <template slot-scope="{ item }">
              <div class="col sim-options-btn-holder">
                <button
                  type="button"
                  class="btn btn-default"
                  v-on:click="contact_no = item"
                  v-bind:class="[
                    'btn btn-block',
                    contact_no == item ? 'btn-primary' : 'btn-outline-primary',
                  ]"
                >
                  {{ maskNumber(item) }}
                </button>
              </div>
            </template>
          </vue-toggle>
        </div>
        <button
          type="button"
          class="btn-primary btn-block verify"
          :disabled="contact_no === ''"
          v-on:click="sendOtp"
        >
          Request an OTP
        </button>
        <div class="row">
            <div class="col text-center">
              <button
                type="button"
                class="btn btn-link text-secondary btn-sm mt-1"
                @click="cancelRegistraion"
              >
                Cancel
              </button>
            </div>
        </div>        
      </div>
    </div>
    <div v-if="otp_sent && !otp_confirmed">
      <div class="activation-inputs">
        <div
          class="form-group"
          v-bind:class="{ 'has-errors': errors.has('otp') }"
        >
          <p class="text-normal">
            A One Time Pin has been sent to your me&amp;you mobile number.
          </p>
          <the-mask
            type="tel"
            mask="###-###"
            v-validate="'required|digits:6'"
            name="otp"
            data-vv-as="OTP"
            placeholder="Enter Your OTP"
            class="form-control"
            v-model="otp"
          />
          <transition name="slide">
            <span class="error-message" v-if="errors.has('otp')"
              >A 6 digit One Time Pin is required.</span
            >
          </transition>
        </div>
        <button
          type="button"
          class="btn-primary btn-block verify"
          v-on:click="confirmOtp"
        >
          Confirm OTP
        </button>
        <div class="row">
          <div class="col text-left">
            <button
              type="button"
              class="btn btn-link text-primary btn-sm mt-1"
              @click="resendOtp"
            >
              Request a new OTP
            </button>
          </div>
          <div class="col text-right">
            <button
              type="button"
              class="btn btn-link text-secondary btn-sm mt-1"
              @click="cancelRegistraion"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import CustomerService from "@/services/customer.service.js";

export default {
  name: "vue-otp",
  props: ["action"],
  data: function () {
    return {
      is_loading: false,
      display_message: false,
      message: "",
      has_error: false,
      otp_sent: false,
      otp_resent: false,
      otp_confirmed: false,
      sub_confirmed: false,
      contact_numbers: [],      
      contact_no: "",
      sim_number: "",
      msisdn: "",
      otp: "",
      is_resend: false,
      response: false,
    };
  },
  watch: {
    is_loading: function (val) {
      EventBus.$emit("global_loading", {
        is_loading: val,
      });
    },
  },
  methods: {
    resetResponse() {
      const self = this;
      self.response = {
        success: false,
        message: "",
        data: null,
      };
    },
    updateResponse(success, message, data) {
      const self = this;
      self.response.success = success;
      self.response.message = message;
      self.response.data = data;
    },
    confirmCustomer() {},
    confirmSubscriber() {
      var self = this;
      self.is_loading = true;
      self.display_message = false;
      self.message = "";
      self.resetResponse();
      CustomerService.confirmSubscriber(self.msisdn, self.sim_number)
        .then(function ({ data }) {
          var response = data;
          self.$log.debug("Confirm subscriber response", response);
          if (response.success && response.data) {
            response.data.msisdns.forEach((number) => {
              if (self.contact_numbers.indexOf(number) === -1) {
                self.contact_numbers.push(number);
              }
              self.msisdn = response.data.msisdns[0];
              self.sub_confirmed = true;
            });
          }
          
          self.is_loading = false;
        })
        .catch(function ({ response }) {
          self.$log.error("Error confirming customer.", response);
          self.has_error = true;
          self.display_message = true;
          self.message = "Error confirming customer.";
          self.is_loading = false;
        });
    },
    sendOtp(is_resend = false) {
      var self = this;
      self.is_loading = true;
      self.display_message = false;
      self.message = "";
      self.resetResponse();
      CustomerService.sendOtp(self.msisdn, self.contact_no)
        .then(function ({ data }) {
          var response = data;
          self.$log.debug("Send OTP response", response);
          if (response.success && response.data) {
            self.$log.debug("OTP Sent");
            self.otp_sent = true;
            if (is_resend) self.is_resend = true;
          }
          self.is_loading = false;
        })
        .catch(function ({ response }) {
          self.$log.error("Error requesting OTP.", response);
          self.has_error = true;
          self.display_message = true;
          self.message = "Error requesting OTP.";
          self.is_loading = false;
        });
    },
    resendOtp() {
      var self = this;
      self.display_message = false;
      self.resetResponse();
      self.sendOtp(true);
    },
    confirmOtp() {
      var self = this;
      self.is_loading = true;
      self.resetResponse();
      self.display_message = false;
      CustomerService.confirmOtp(self.msisdn, self.otp, self.action)
        .then(function ({ data }) {
          var response = data;
          self.$log.debug("Confirm OTP response", response);
          if (response.success) {
            self.$log.debug("OTP Confirmed");
            self.otp_confirmed = true;
            self.order_id = response.data.order_id;
            self.updateResponse(true, "OTP Confirmed", response.data);
          } else {
            self.display_message = true;
            self.message = response.message;
            self.has_error = true;
            self.updateResponse(false, response.message, null);
          }
          self.is_loading = false;
        })
        .catch(function ({ response }) {
          self.$log.error("Error confirming OTP", response);
          self.has_error = true;
          self.display_message = true;
          self.message = "Error confirming OTP";
          self.is_loading = false;
          self.updateResponse(false, "Error confirming OTP", response);
        })
        .finally(function () {
          self.$emit("response", self.response);
        });
    },
    cancelRegistraion() {
      const self = this;
      self.display_message = false;
      self.has_error = false;
      self.otp_sent = false;
      self.otp_resent = false;
      self.otp_confirmed = false;
      self.sub_confirmed = false;
      self.contact_numbers = [];
      self.contact_no = "";
      self.otp = "";
      self.is_loading = false;
      self.user_name = "";
      self.password = "";
      self.sim_number = "";
      self.msisdn = "";
    },
    maskNumber(num) {
      var index = 3;
      var replacement = "XXXX";
      return (
        num.substr(0, index) +
        " " +
        replacement +
        " " +
        num.substr(index + replacement.length)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>